import React from 'react'
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./ValidMessages.css";
const ValidTORMessages = ({ validlistError }) => {

    return (
        <TransitionGroup component="ul" className="text-danger mt-2">
            {validlistError.map((message, index) => (
                <CSSTransition
                    key={index}
                    timeout={300}
                    classNames="feedback-message"
                >
                    <li>{message}</li>
                </CSSTransition>
            ))}
        </TransitionGroup>
    )
}

export default ValidTORMessages